function e(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}export{e as default};
//# sourceMappingURL=nonIterableSpread.js.map
